import { Product, ProductsService } from '../api';

interface ProductProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Product[]; total: number }>;
  create: (resource: string, params: any) => Promise<{ data: Product }>;
  getOne: (resource: string, params: any) => Promise<{ data: Product }>;
  update: (resource: string, params: any) => Promise<{ data: Product }>;
}

export const productProvider: ProductProviderResource = {
  getList: async (resource, paramms) => {
    const { items } = await ProductsService.productsList();
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: items,
      total: items.length,
    };
  },
  create: async (resource, params) => {
    console.log(params);
    const product = await ProductsService.productsAdd(params.data);
    return { data: product };
  },
  getOne: async (resource, params) => {
    const product = await ProductsService.getProduct(params.id);
    return { data: product };
  },
  update: async (resource, params) => {
    console.log(params);
    const {
      data: { article, name, description, price, count, is_active },
    } = params;
    const product = await ProductsService.updateProduct(params.id, {
      article,
      name,
      description,
      price,
      count,
      is_active,
    });
    return { data: product };
  },
};
